import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-be636fe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile_story_top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "more" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Our Story")
], -1))
const _hoisted_3 = { class: "pic" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dec" }, [
  /*#__PURE__*/_createTextVNode(" Sixliv, founded to transform healthcare with AI, unites experts from technology and healthcare. "),
  /*#__PURE__*/_createElementVNode("p", null, " Our team, including alumni from the University of Chicago and Imperial College London, has led AI projects worth over $15 billion ")
], -1))

import { onMounted } from "vue";

import { reactive } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileStory ',
  setup(__props) {

const pageTopPic = reactive({
  url: "",
});

onMounted(() => {
  console.log(localStorage.getItem("PAGE_MODEL_3"));
  if (localStorage.getItem("PAGE_MODEL_3")) {
    pageTopPic.url = JSON.parse(localStorage.getItem("PAGE_MODEL_3") || "").url || "";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: pageTopPic.url,
        alt: ""
      }, null, 8, _hoisted_4)
    ]),
    _hoisted_5
  ]))
}
}

})